export interface WarrantyCoverageDisplayRow {
  coverageId: string;
  coverage?: {
    order?: number | null;
    title?: string | null;
  } | null;
}

export function compareWarrantyCoverageDisplayOrder(
  a: WarrantyCoverageDisplayRow,
  b: WarrantyCoverageDisplayRow
): number {
  const orderCompare = (a.coverage?.order ?? Number.MAX_SAFE_INTEGER) - (b.coverage?.order ?? Number.MAX_SAFE_INTEGER);

  if (orderCompare !== 0) return orderCompare;

  return (a.coverage?.title ?? a.coverageId).localeCompare(b.coverage?.title ?? b.coverageId);
}
